import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';

@Component({
    selector: 'fi-customer-settings-preview-mobile-app',
    templateUrl: './customer-settings-preview-mobile-app.component.html',
    styleUrls: ['./customer-settings-preview-mobile-app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-customer-settings-preview-mobile-app' },
    standalone: false,
})
export class FiCustomerSettingsPreviewMobileAppComponent {
    constructor(private customerDataService: FiCustomerDataService) {}

    getCustomerName(): string {
        return this.customerDataService.customerData.DisplayName;
    }
}
